export default "__VITE_ASSET__BaEYE1Uw__"